export const METADATA_CONSTANTS = {
    CONSENT_TYPE: {
      SUBSCRIPTION: 'subscription',
      CONNECTION: 'connection'
    },
  
    REQUESTED_STATUS: {
      ENABLE: 'enable',
      DISABLE: 'disable',
      NEW: 'new',
      SUBSCRIBE: 'subscribe',
      UNSUBSCRIBE: 'unsubscribe'
    },
    STATUS: {
      ENABLED: 'enabled',
      DISABLED: 'disabled',
      SUBSCRIBED: 'subscribed',
      UNSUBSCRIBED: 'unsubscribed',
      PENDING: 'pending'
    },
    BULK_OPERATIONS: {
      ENABLE: 'enable',
      DISABLE: 'disable'
    }
  };
  